import { MbIconText, MbIcon, MbDialog } from '@am/moebius';
import { Component, Input } from '@angular/core';
import { DateService } from '@services/date.service';
import { SearchBoxModalComponent } from '../searchbox-modal/searchbox-modal.component';

@Component({
  selector: 'am-searchbox-summary',
  standalone: true,
  styleUrls: ['./searchbox-summary.component.scss'],
  templateUrl: './searchbox-summary.component.html',
  imports: [MbIconText, MbIcon],
})
export class SearchBoxSummaryComponent {
  @Input()
  public searchboxData: any;

  constructor(private dateService: DateService, private dialog: MbDialog) {}

  public togglesOpenDialog() {
    this.dialog.open(SearchBoxModalComponent, {
      closeOnEscKey: true,
      dialogData: this.searchboxData,
      closeBtn: true,
    });
  }

  public formatDate(date) {
    return this.dateService.formatDateToShow(date);
  }
}
